import React, { Component } from 'react';
import packageJson from '../../package.json';
import {
    Layout,
    Menu,
    Icon,
    Alert
} from 'antd';
import AuthService from './AuthService';
import WithAuth from './WithAuth';
import { Offline } from 'react-detect-offline';

import UserProvider from '../js/userProvider';

const { Header, Sider, Content, Footer } = Layout;

const Auth = new AuthService();

const menuStyle = {
    marginRight: '20px'
};

const contentStyle = {
    padding: '20px',
    minWidth: '280px',
    paddingTop: '84px'
};

class LayoutPages extends Component {

    constructor(props) {
        super(props);

        this.state = {
            collapsed: true,
            current: this.props.page.pageIndex,
            paginas: []
        }

        this.toggle = () => {
            this.setState({
                collapsed: !this.state.collapsed,
            });
        }

        this.handleClick = this.handleClick.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.menusOcultos =[];

        this.dadosProvider = UserProvider.getInstance();
        this.usuario = this.dadosProvider.getDadosUsuario();
    };

    componentWillMount() {
        this.menusOcultos = this.dadosProvider.getMenusOcultos();

        var paginas = [
            { id: 1, nome: "Home", pagina: "/", icon: "home", cdMenu: null, stAtivo: 1},
            { id: 2, nome: "Corridas Finalizadas", pagina: "/corridas-finalizadas", icon: "check-circle-o", cdMenu: 155, stAtivo: 1 },
            { id: 3, nome: "Rastrear Veiculo", pagina: "/rastrear-veiculos", icon: "car", cdMenu: 156, stAtivo: 1 },
            { id: 4, nome: "Histórico de PA", pagina: "/historico-pa", icon: "unordered-list", cdMenu: 183, stAtivo: 1 },
            { id: 5, nome: "Minha Carteira", pagina: "/minha-carteira", icon: "wallet", cdMenu: 157, stAtivo: 1 },
            { id: 6, nome: "Documentos", pagina: "/documentos", icon: "file", cdMenu: 164, stAtivo: 1 },        
            { id: 7, nome: "Perfil", pagina: "/perfil", icon: "user", cdMenu: 158, stAtivo: 1 },     
            { id: 8, nome: "Sair", pagina: "/logout", icon: "logout", cdMenu: null, stAtivo: 1 },
        ];

        for (let i = 0; i < paginas.length; i++) {
            paginas[i]["stAtivo"] = (this.menusOcultos.indexOf(paginas[i]["cdMenu"]) == -1) ? 1 : 0;
        }

        //{ id: 8, nome: "Notificar Clientes", pagina: "/notificar-clientes", icon: "notification" },

        this.setState({ paginas: paginas })
    }

    handleLogout(e) {
        Auth.logout();

        this.props.page.history.push('/login');
    }

    handleClick(e) {

        this.setState({
            collapsed: !this.state.collapsed,
            current: e.key,
        });

        var pagina = this.state.paginas[e.key - 1];

        if (pagina.pagina === "/logout") {
            this.handleLogout(e);
        } else {
            //setTimeout( () => {
                this.props.page.history.push(pagina.pagina);
            //}, 200)
            
        }

    };

    render() {

        return (
            <Layout className="App" style={{ height: "100vh" }}>
                <Sider
                    trigger={null}
                    breakpoint="lg"
                    collapsedWidth="0"
                    collapsible
                    collapsed={this.state.collapsed}>

                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%'}}>
                        <Menu
                            theme="dark"
                            mode="inline"
                            selectedKeys={[this.state.current]}
                            onClick={this.handleClick}>
                            {this.state.paginas.map((pagina, index) =>{
                                if(pagina.stAtivo == 1){
                                    return (
                                        <Menu.Item key={pagina.id}>
                                            <Icon type={pagina.icon} />
                                            {pagina.nome}
                                        </Menu.Item>
                                    )
                                }
                            })}                        
                        </Menu>
                        <div style={{fontSize: '.7rem', fontStyle: 'italic', color: 'white', textAlign: 'right', padding: '5px', whiteSpace: "nowrap"}}>
                            v {packageJson.version}
                        </div>
                    </div>
                </Sider>
                <Layout>
                    <Header className="App-header" style={{ position: 'fixed', width: '100%', zIndex: 100 }}>
                        <div style={{flex: '1', whiteSpace: 'nowrap'}}>
                            <Icon
                                style={menuStyle}
                                type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                                onClick={this.toggle} />
                            <span>
                                {this.props.page.pageTitle}
                            </span>
                        </div>
                        {
                            this.usuario.DsTipoCondutor ?
                            <span style={{fontSize: '.7em', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: 'normal', textAlign: 'right'}}>
                                {this.usuario.DsTipoCondutor} - {this.usuario.NrPrefixo} ({this.usuario.DsCodiNomeEstabelecimento}) 
                            </span> :
                            <spa></spa>
                        }
                    </Header>
                    <Offline>
                        <Alert className="AppAlert" message="Você está navegando em modo offline" type="warning" showIcon />
                    </Offline>
                    <Content style={contentStyle}>

                        {this.props.page.children}
                    </Content>
                </Layout>
            </Layout>
        )
    }
}

export default WithAuth(LayoutPages);


// WEBPACK FOOTER //
// ./src/Components/LayoutPages.js